export enum AttachmentLabels {
  INDIVIDUAL = 'Individual',
  CSV = 'CSV',
  CSV_WITH_ACCESSORIAL = 'CSV w/ Accessorial',
  PDF = 'PDF',
  PDFI = 'PDF With Images',
  XML = 'XML',
  PAPER = 'Paper',
}
